import { Form, Input, Grid, Select, DatePicker2, Upload, Icon, Field, Dialog, Button } from "@alifd/next";
import { BefGlobalContext, BefMessageServiceContext, BefRpcContext } from "@beflam/bef-core";
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import ChangePassword from "./ChangePassword";

export function BefUserAvatar(props: any) {
    const { value, ...otherProps } = props;
    const sGlobal = useContext(BefGlobalContext);
    return (
        <div {...otherProps}>
            <img style={{ maxWidth: "100%", maxHeight: "100%", position: "absolute", top: 0, right: 0, bottom: 0, left: 0, margin: "auto" }}
                alt={value} src={`${sGlobal.config.host}/${value}`}></img>
        </div>
    );
}
const EditUserDialog = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, id, readonly, isUser, ...otherProps } = props;
    const befRpc = useContext(BefRpcContext);
    const messageService = useContext(BefMessageServiceContext);
    const sGlobal = useContext(BefGlobalContext);
    const [dataSource, setDataSource] = useState<any>({});
    let [visible, setVisible] = useState({ changePassword: false });
    let contextComp: any = {};
    contextComp.setState = (data: any) => {
        setDataSource(data);
    }
    const fieldRef = useRef(new Field(contextComp));

    const setVisibleEx = (data: any) => {
        visible = data;
        setVisible(data);
    }
    const refresh = async () => {
        try {
            const result = await befRpc.callRpcAsync<any>("", rpcAssembly, rpcModule, "Get", { UserId: id });
            fieldRef.current.setValues(result);
            if (result.Avatar) {
                let url = `${sGlobal.config.host}/${result.Avatar}`;
                fieldRef.current.setValue("AvatarUploadData", [{
                    name: result.Avatar,
                    state: "done",
                    size: 1024,
                    downloadURL: url,
                    fileURL: url,
                    imgURL: url
                }]);
            } else {
                fieldRef.current.setValue("AvatarUploadData", []);
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "用户信息获取"));
        }
    }
    const saveData = async () => {
        let data: any = fieldRef.current.getValues();
        let result = await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "Update", data);
        messageService.showMessage({ mes: `修改用户<${data.UserId}>信息成功` });
        return result;
    }
    const save = async () => {
        try {
            await saveData();
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "用户信息保存"));
        }
    }

    let userRef = useRef<any>(null);
    const openChangePasswordDialog = () => {
        try {
            setVisibleEx({ ...visible, changePassword: true });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "修改密码"));
        }
    }
    const onChangePassword = async () => {
        try {
            if (!userRef || !userRef.current) throw new Error("系统错误：userRef is null");
            let validateResult = await userRef.current.validate();
            if (validateResult.errors != null) return;
            let data = userRef.current.dataSource;
            data.Reset = true;
            await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "ChangePassword", data);
            messageService.showMessage({ mes: `修改密码成功` });
            setVisibleEx({ ...visible, changePassword: false });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "修改密码"));
        }
    }

    const onAvatarUploadChange = (value: any[]) => {
        let data = null;
        if (value && value.length > 0) {
            data = value[0].response?.fileId;
        }
        fieldRef.current.setValue("Avatar", data);
    }
    const uploadFormatterHandler = (response: any, file: File) => {
        return {
            success: response.success,
            message: response.success ? "上传成功" : response.error,
            url: `${sGlobal.config.host}/${response.fileId}`,
            fileId: response.fileId
        };
    }

    useEffect(() => {
        fieldRef.current.reset();
    }, []);
    useEffect(() => {
        if (id) {
            fieldRef.current.setValue("UserId", id);
            refresh();
        }
    }, [id]);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        Object.defineProperty(proxy, 'dataSource', {
            get() {
                let result: any = fieldRef.current.getValues();
                return result;
            }
        });
        proxy.validate = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate((errors: any, values: any) => {
                        resolve({ errors, values });
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        proxy.save = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate(async (errors: any, values: any) => {
                        try {
                            if (errors != null) return;
                            let result = await saveData();
                            resolve(result);
                        } catch (error) {
                            reject(error);
                        }
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        return proxy;
    }, [rpcAssembly, rpcModule]);
    return (
        <div className="bef-custom-user">
            <Form field={fieldRef.current} disabled={readonly}>
                <Grid.Row gutter="24">
                    {/* <Grid.Col>
                        <Form.Item required label="GUID" name="Id">
                            <Input disabled />
                        </Form.Item>
                    </Grid.Col> */}
                    <Grid.Col>
                        <Form.Item required label="用户编号" name="UserId" className="custom-form-control">
                            <Input disabled />
                        </Form.Item>
                    </Grid.Col>
                    <Grid.Col>
                        <Form.Item label="用户名" name="UserName" className="custom-form-control">
                            <Input />
                        </Form.Item>
                    </Grid.Col>
                    <Grid.Col>
                        <Form.Item label="用户密码" name="Password" className="custom-form-control">
                            <Input.Password disabled />
                        </Form.Item>
                    </Grid.Col>
                </Grid.Row>
                <Grid.Row gutter="24">
                    <Grid.Col>
                        <Form.Item label="性别" name="Gender" className="custom-form-control">
                            <Select style={{ width: '100%' }} >
                                <Select.Option value={0}>女</Select.Option>
                                <Select.Option value={1}>男</Select.Option>
                            </Select>
                        </Form.Item>
                    </Grid.Col>
                    <Grid.Col>
                        <Form.Item label="出生日期" name="Birthday" className="custom-form-control">
                            <DatePicker2 style={{ width: '100%' }} />
                        </Form.Item>
                    </Grid.Col>
                    <Grid.Col>
                        <Form.Item label="语言" name="Language" className="custom-form-control">
                            <Select style={{ width: '100%' }} >
                                <Select.Option value="zh-CN">中文</Select.Option>
                                <Select.Option value="en-US">英文</Select.Option>
                            </Select>
                        </Form.Item>
                    </Grid.Col>
                </Grid.Row>
                {!isUser &&
                    <Grid.Row gutter="24">
                        <Grid.Col>
                            <Form.Item required label="状态" name="State" className="custom-form-control">
                                <Select style={{ width: '100%' }} >
                                    <Select.Option value="AC">激活</Select.Option>
                                    <Select.Option value="LC">锁定</Select.Option>
                                    <Select.Option value="DL">删除</Select.Option>
                                    <Select.Option value="RP">重置</Select.Option>
                                </Select>
                            </Form.Item>
                        </Grid.Col>
                        <Grid.Col>
                            <Form.Item label="生效日期" name="ValidateDate" className="custom-form-control">
                                <DatePicker2 style={{ width: '100%' }} />
                            </Form.Item>
                        </Grid.Col>
                        <Grid.Col>
                            <Form.Item label="失效日期" name="ExpireDate" className="custom-form-control">
                                <DatePicker2 style={{ width: '100%' }} />
                            </Form.Item>
                        </Grid.Col>
                    </Grid.Row>
                }
                <Grid.Row gutter="24">
                    <Grid.Col>
                        <Form.Item label="邮箱" name="Email" className="custom-form-control">
                            <Input />
                        </Form.Item>
                    </Grid.Col>
                    <Grid.Col>
                        <Form.Item label="手机号码" name="PhoneNumber" className="custom-form-control">
                            <Input />
                        </Form.Item>
                    </Grid.Col>
                    <Grid.Col>
                        <Form.Item label="办公电话" name="TelNumber" className="custom-form-control">
                            <Input />
                        </Form.Item>
                    </Grid.Col>
                </Grid.Row>
                <Grid.Row gutter="24">
                    <Grid.Col span={8}>
                        <Form.Item label="身份证件号码" name="IdentityNumber" className="custom-form-control">
                            <Input />
                        </Form.Item>
                    </Grid.Col>
                    <Grid.Col span={16}>
                        <Form.Item label="地址" name="Address" className="custom-form-control">
                            <Input />
                        </Form.Item>
                    </Grid.Col>
                </Grid.Row>
                <Grid.Row gutter="24">
                    <Grid.Col>
                        {!readonly && <Form.Item label="头像" name="AvatarUploadData" className="custom-form-control">
                            <Upload.Card className="bef-user-avatar-list-item-name-hide"
                                limit={1} reUpload listType="card" accept="image/*" dragable
                                disabled={readonly} action={sGlobal.config.host + "/upload"}
                                data={{ path: `${sGlobal.currentAppId}/user/avatar/${id}`, sessionId: sGlobal.session.id }}
                                formatter={uploadFormatterHandler} onChange={onAvatarUploadChange}>
                            </Upload.Card>
                        </Form.Item>}
                        {readonly && <Form.Item label="头像" name="Avatar" className="custom-form-control">
                            <BefUserAvatar style={{ position: "relative", border: "1px solid #c4c6cf", width: "100px", height: "100px" }}></BefUserAvatar>
                        </Form.Item>}
                    </Grid.Col>
                </Grid.Row>
            </Form>
            <Dialog v2 title="修改密码" width={400} visible={visible.changePassword}
                onClose={() => setVisibleEx({ ...visible, changePassword: false })} onOk={onChangePassword}>
                <ChangePassword ref={userRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule} id={id} />
            </Dialog>
        </div>
    );
});

export default EditUserDialog;